import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";

const setSwiper = (card) => {
    const swiperContainer = card.querySelector('.c-cards-estate__thumbnail');
    if(!swiperContainer) return;
    if (swiperContainer.querySelector('.swiper-wrapper') == null) return;
    // 子要素が1つだけならSwiperを初期化しない
    if (swiperContainer.querySelector('.swiper-wrapper').children.length <= 1) return;

    // 現地販売会用はSwiperを初期化しない
    if(swiperContainer.hasAttribute('data-sales')) return;

    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        slidesPerView: 2.1,
        speed: 4000,
        autoplay: {
            delay: 0, // 遅延なしで連続再生
            disableOnInteraction: false, // ユーザー操作後も自動再生を継続
        },
        allowTouchMove: false, // タッチ操作を無効化（連続再生のため）
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            769: {
                speed: 300,
                slidesPerView: 1,
                autoplay: false,
                allowTouchMove: {
                    delay: 500
                },
            }
        }
    });

    // 初期状態でオートプレイを停止
    swiper.autoplay.stop();

    // Intersection Observerを設定
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                console.log('in view');
                // 画面内に入った時、オートプレイを開始
                swiper.autoplay.start();
            } else {
                console.log('out of view');
                // 画面外に出た時、オートプレイを停止
                swiper.autoplay.stop();
            }
        });
    }, {
        threshold: 0.1, // 10%が見えたら発火
        rootMargin: '0px'
    });

    // Swiperコンテナを監視対象に追加
    observer.observe(card);
}

const main = () => {
    if (document.querySelectorAll('.c-cards-estate') === null) return;

    document.querySelectorAll('.c-cards-estate').forEach(card => {
        setSwiper(card);
    });
}

export default main;
